import operationDocumentList from "./operation";

export default operationDocumentList;
